import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

import { PaymentMethod } from "../../models";
import { RQ } from "../../globals/enums";
import { add } from "../../api/generic-api";

export const useAddPaymentMethod = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(
    (paymentMethod: PaymentMethod) =>
      add<PaymentMethod>("payment-methods", paymentMethod),
    {
      onSuccess: (paymentMethod) => {
        enqueueSnackbar("Payment Method Added", { variant: "success" });
        queryClient.setQueryData<PaymentMethod[]>(
          RQ.PAYMENT_METHODS,
          (paymentMethods: PaymentMethod[] | undefined) => {
            return [...(paymentMethods ?? []), paymentMethod];
          }
        );
      },
      onError: () => {
        enqueueSnackbar("Payment Method Adding Error", { variant: "error" });
      },
    }
  );
};
